import {
  getDB,
  addDBItem,
  getAllDBItems,
  getDBItem,
} from "@/common/browserDb/browserDb";

export { _addFeedbackLoopItem as addFeedbackLoopItem };
export { _getAllFeedbackLoopItems as getAllFeedbackLoopItems };
export { _getFeedbackLoopItem as getFeedbackLoopItem };

const DB_NAME = "ArticleFeedback";
const STORE_NAME = "articles";
const INDEXES = "[eventType+esId],createdTime,thumbsUp";

const _getDB = () => {
  return getDB({
    dbName: DB_NAME,
    storeName: STORE_NAME,
    indexes: INDEXES,
  });
};

const _addFeedbackLoopItem = async (params) => {
  const DB = _getDB();
  let payload = {
    eventType: params.eventType,
    esId: params.esId,
    createdTime: new Date().toISOString(),
  };
  if (params.hasOwnProperty("badGeo")) {
    payload.badGeo = params.badGeo;
  }
  if (params.hasOwnProperty("thumbsUp")) {
    payload.thumbsUp = params.thumbsUp;
  }
  return await addDBItem({
    db: DB,
    store: STORE_NAME,
    payload: payload,
  });
};

const _getAllFeedbackLoopItems = async () => {
  const DB = _getDB();
  return await getAllDBItems({
    db: DB,
    store: STORE_NAME,
  });
};

const _getFeedbackLoopItem = async (params) => {
  const DB = _getDB();
  return await getDBItem({
    db: DB,
    store: STORE_NAME,
    payload: {
      eventType: params.eventType,
      esId: params.esId,
    },
  });
};
